import React, { useState } from "react";
import { api } from "../../utils";
import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import Divider from "@mui/material/Divider";

export default function ForgotPassword(props) {
  const [email, setEmail] = useState();
  const [submitted, setSubmitted] = useState(false);

  function forgotPassword() {
    api.post("account/forgotPassword", { username: email }).then((res) => {
      setSubmitted(true);
    });
  }

  return (
    <Container maxWidth="sm">
      <Card>
        <CardHeader
          title={
            <Typography variant="articleTitle">Forgot Password?</Typography>
          }
        />
        {!submitted ? (
          <>
            <CardContent>
              <Stack spacing={3}>
                <Typography variant="articleText" sx={{ marginBottom: "1rem" }}>
                  Please enter the email address associated with your account to
                  be sent a reset password link.
                </Typography>
                <Divider />
                <TextField
                  required
                  color="primary"
                  type="email"
                  onChange={(e) => setEmail(e.target.value)}
                  label={<Typography variant="navText">Email</Typography>}
                />
              </Stack>
            </CardContent>
            <CardActions>
              <Button
                size="small"
                color="success"
                variant="contained"
                onClick={() => forgotPassword()}
              >
                Get Link
              </Button>
            </CardActions>
          </>
        ) : (
          <>
            <CardContent>
              <Typography variant="articleText">
                If the email you submitted is in our system, you will receive a
                reset password link sent to the email address in the next few
                minutes. The link expires after 24 hours.
              </Typography>
              <Typography variant="articleText">
                If you have not recieved an email from our system, please check
                your SPAM folder before using "Forgot Password" again.
              </Typography>
            </CardContent>
          </>
        )}
      </Card>
    </Container>
  );
}
